import React from 'react'
import { ShopHereBtn } from '../Template'
import GallerySlider from '../GallerySlider'
import './landing_page.css'
import './landing_page_desktop.css'


export default function LandingPage() {

    const highlights_photos = [
        {
            url: 'img/highlights_gallery/black_swirls_catear_beanie.jpg',
            description: 'black swirls cat ear beanie'
        },
        {
            url: 'img/highlights_gallery/purple_swirls_catear_beanie.jpg',
            description: 'purple swirls cat ear beanie'
        },
        {
            url: 'img/highlights_gallery/plum scrunchie.jpg',
            description: 'plum scrunchie'
        },
        {
            url: 'img/highlights_gallery/star bag.jpg',
            description: 'star bag'
        },
        {
            url: 'img/highlights_gallery/flower top.jpg',
            description: 'flower pattern crocheted top'
        }
    ]

    return (
        <React.Fragment>
            <div className="landingpg-container">
                <section className='landingpg-intro'>
                    <div id="landingpg-greeting">
                        <h2 className='landingpg-greeting-txt'>Crochetedly, Tori</h2>
                        <h5 className='landingpg-greeting-txt'>Handmaking pieces that are as unique as the people wearing them.</h5>
                        <ul className='landingpg-greeting-txt'>
                            <li>One-of-a-kind crocheted accessories and cat ear beanies</li>
                            <li>Handmade with leftover and/or thrifted yarn; no two pieces are the same</li>
                            <li>Created for people who love to wear their personality</li>
                            <li>If you see something you like, grab it. There are almost never any duplicates</li>
                        </ul>

                        <div className='landingpg-greeting-txt'>
                            <ShopHereBtn />
                        </div>
                    </div>
                    <div className='landingpg-portrait-wrapper'>
                        {/** TODO: find a better way to do the circle, e.g. using a transparent background.  
                     * This is probably not best practice since there can be no alt value (shows on top of the image since the src is empty) */}
                        {/* <img className='landingpg-portrait' alt='' /> */}
                    </div>
                </section>

            </div>
            <section className='main-content highlights-gallery'>
                <GallerySlider photos={highlights_photos} />
            </section>
            <br /><br />
        </React.Fragment>
    )
}

